<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  conversations: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  formatWaitingTime: { type: Function, required: true },
});

const emit = defineEmits(['claim', 'open', 'copy']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section
    class="rounded-lais border border-lais-border bg-white p-4 shadow-lais-card"
  >
    <div class="flex flex-wrap items-center justify-between gap-3">
      <div>
        <p class="text-[11px] font-semibold uppercase text-lais-text-muted">
          Atendimento online
        </p>
        <h3 class="mt-1 text-[18px] font-semibold text-lais-text">
          Fila pendente
          <span
            class="ml-2 rounded-full bg-lais-primary px-2.5 py-0.5 text-[12px] font-semibold text-white"
          >
            {{ conversations.length }}
          </span>
        </h3>
      </div>
    </div>

    <div
      v-if="loading && !conversations.length"
      class="mt-4 flex gap-3 overflow-hidden"
    >
      <div
        v-for="index in 3"
        :key="index"
        class="h-36 min-w-[260px] animate-pulse rounded-lais bg-lais-bg-muted"
      />
    </div>

    <div
      v-else-if="!conversations.length"
      class="mt-4 grid min-h-[144px] place-items-center rounded-lais border border-dashed border-lais-border bg-lais-bg-soft px-4 text-center"
    >
      <div>
        <span
          class="i-lucide-info mx-auto block size-8 text-lais-text-muted"
          aria-hidden="true"
        />
        <p class="mt-3 text-[14px] font-semibold text-lais-text">
          Nenhum cliente aguardando no plantão
        </p>
      </div>
    </div>

    <div v-else class="mt-4 flex gap-3 overflow-x-auto pb-1 no-scrollbar">
      <article
        v-for="(conversation, index) in conversations"
        :key="conversation.id"
        class="min-w-[280px] rounded-lais border bg-white p-4"
        :class="
          index === 0
            ? 'border-lais-primary ring-2 ring-lais-primary-50'
            : 'border-lais-border-soft'
        "
      >
        <div class="flex items-start justify-between gap-3">
          <div class="min-w-0">
            <p class="truncate text-[15px] font-semibold text-lais-text">
              {{ conversation.contact?.name || 'Cliente sem nome' }}
            </p>
            <p class="mt-1 truncate text-[12px] text-lais-text-muted">
              {{ conversation.inbox?.name || 'Inbox' }}
            </p>
          </div>
          <span
            class="shrink-0 rounded-full bg-lais-gold/15 px-2.5 py-1 text-[12px] font-semibold text-lais-gold"
          >
            {{ formatWaitingTime(conversation.duty?.waiting_seconds) }}
          </span>
        </div>

        <div class="mt-4 flex flex-wrap gap-2">
          <LaisPrimaryButton
            size="sm"
            icon="i-lucide-play"
            @click="emit('claim', conversation)"
          >
            Iniciar
          </LaisPrimaryButton>
          <LaisPrimaryButton
            size="sm"
            variant="ghost"
            icon="i-lucide-external-link"
            @click="emit('open', conversation)"
          >
            Abrir
          </LaisPrimaryButton>
          <LaisPrimaryButton
            size="sm"
            variant="ghost"
            icon="i-lucide-copy"
            @click="emit('copy', conversation)"
          >
            Copiar
          </LaisPrimaryButton>
        </div>
      </article>
    </div>
  </section>
</template>
